import { makeStyles } from "@material-ui/core/styles";
import { FooterControlsStyles } from "./footer-controls.component";

export const footerControlsStyles = makeStyles((theme) => ({
  flexEnd: {
    display: "flex",
    alignItems: "center",
    justifyContent: ({ step }: FooterControlsStyles) =>
      step === "CREATE_USER" ? "center" : "flex-end",
    [theme.breakpoints.down("xs")]: {
      justifyContent: ({ step }: FooterControlsStyles) =>
        step === "LIFE_EVENT" ? "flex-end" : "space-evenly",
      paddingInlineEnd: 0,
    },
    paddingBottom: theme.spacing(12),
  },
  innerContainer: {
    width: "500px",
    display: "flex",
    justifyContent: "flex-end",
    [theme.breakpoints.up("md")]: {
      width: "500px",
    },
    [theme.breakpoints.down("md")]: {
      width: "350px",
    },
  },
  controls: {
    backgroundColor: "#0344DC",
    color: "white",
    fontFamily: "Inter",
    fontWeight: "bold",
    height: "43px",
    margin: "0px 10px",
    borderRadius: "100px",
    textTransform: "none",
    padding: "12px 24px 12px 24px",
    "&:hover": {
      backgroundColor: "#0344DC !important",
    },
    "&.Mui-disabled": {
      color: "#666666",
      border: "1px solid #999999",
      backgroundColor: "#E6E6E6",
    },
  },
  back: {
    backgroundColor: "#F1F5FF",
    color: "#0344DC",
    "&:hover": {
      backgroundColor: "#F1F5FF !important",
    },
  },
  skip: {
    backgroundColor: "transparent",
    color: "#0344DC",
    "&:hover": {
      backgroundColor: "transparent !important",
    },
  },
  icon: {
    marginLeft: 4,
    marginTop: -2,
    fontWeight: "bold",
    fontFamily: "Inter",
    fontSize: "16px",
  },
  iconEnabled: {
    color: ({ isNextButtonDisabled }: FooterControlsStyles) =>
      isNextButtonDisabled ? "lightgray" : "#22D9BB",
  },
}));
